import addUpdate from './addUpdate';
export default addUpdate;